export default __webpack_public_path__ + "static/media/xenia.f7d4265c.png";